import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "label", "name"]

  connect() {
    this.labelTarget.addEventListener("dragover", this.onDragOver)
    this.labelTarget.addEventListener("dragleave", this.onDragLeave)
    this.labelTarget.addEventListener("drop", this.onDrop)
  }

  disconnect() {
    this.labelTarget.removeEventListener("dragover", this.onDragOver)
    this.labelTarget.removeEventListener("dragleave", this.onDragLeave)
    this.labelTarget.removeEventListener("drop", this.onDrop)
  }

  onDragOver = (e) => {
    e.preventDefault()
    this.labelTarget.classList.add("drag-over")
  }

  onDragLeave = () => {
    this.labelTarget.classList.remove("drag-over")
  }

  onDrop = (e) => {
    e.preventDefault()
    this.labelTarget.classList.remove("drag-over")
    const file = e.dataTransfer.files[0]
    if (file) {
      this.inputTarget.files = e.dataTransfer.files
      this.showFile(file.name)
    }
  }

  changed() {
    const file = this.inputTarget.files[0]
    if (file) {
      this.showFile(file.name)
    }
  }

  showFile(name) {
    this.labelTarget.classList.add("has-file")
    this.nameTarget.textContent = name
  }
}
